var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2376.2 2376.2",
    style: {
      enableBackground: "new 0 0 2376.2 2376.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M824.3 0h729c665.8 0 823 158.4 823 824.3v729c0 665.8-158.4 823-824.3 823H823c-665.8 0-823-158.4-823-824.3V823C0 158.4 158.4 0 824.3 0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00405b"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M824.3 0h729c665.8 0 823 158.4 823 824.3v729c0 665.8-158.4 823-824.3 823H823c-665.8 0-823-158.4-823-824.3V823C0 158.4 158.4 0 824.3 0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-61.9-61.9h2500v2500h-2500v-2500z",
    style: {
      clipPath: "url(#b)",
      fill: "#00405b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945.5 818.1c11.1-37.1 0-63.1-52-63.1h-173.3c-44.6 0-64.4 23.5-75.5 49.5 0 0-87.9 215.3-212.9 354-40.8 40.8-58.2 53.2-80.4 53.2-11.1 0-27.2-12.4-27.2-49.5V818.1c0-44.6-12.4-63.1-49.5-63.1h-272.3c-27.2 0-44.6 21-44.6 39.6 0 42.1 61.9 52 69.3 168.3v255c0 55.7-9.9 65.6-32.2 65.6-58.2 0-201.7-215.3-285.9-462.9-17.3-45.8-33.4-65.6-78-65.6H457.9c-49.5 0-59.4 23.5-59.4 49.5 0 45.8 58.2 273.5 273.5 574.3 143.6 205.4 345.3 316.8 528.5 316.8 110.1 0 123.8-24.8 123.8-66.8v-155.9c0-49.5 9.9-59.4 45.8-59.4 26 0 69.3 12.4 172 111.4 117.6 117.6 137.4 170.8 203 170.8h173.3c49.5 0 74.3-24.8 59.4-73-16.1-48.3-71.8-118.8-146-203-40.8-48.3-101.5-99-118.8-125-26-33.4-18.6-48.3 0-76.7-.1-1.4 211.5-298.4 232.5-399.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVk);
export default __webpack_public_path__ + "static/media/icon-vk.f8747bd5e94c92f80785960f0a157097.svg";
export { ForwardRef as ReactComponent };